<template>
  <v-btn
    v-if="isVisible"
    class="gamayun-button align-self-center text-none"
    data-cy="gamayun-button"
    text
    @click="openGamayun"
  >
    Гамаюн
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';

import { getGamayunLaunchUrl, getGamayunOrigin } from '@/helpers/gamayun.helper';
import { NotificationHelper } from '@/helpers/notification.helper';
import { cancelGamayunLaunch, launchGamayun } from '@/services/gamayun-launcher';

export default {
  computed: {
    ...mapGetters('auth/account', ['user']),

    /** @returns {string | null} */
    launchUrl() {
      return getGamayunLaunchUrl();
    },
    /** @returns {boolean} */
    isVisible() {
      return Boolean(this.launchUrl && this.user);
    },
  },
  beforeDestroy() {
    cancelGamayunLaunch();
  },
  methods: {
    openGamayun() {
      const isOpened = launchGamayun({
        launchUrl: this.launchUrl,
        gamayunOrigin: getGamayunOrigin(),
        getEmployee: () => this.user,
        onError: () => NotificationHelper.showError('Could not pass the session to Gamayun. Try again.'),
      });

      if (!isOpened) {
        NotificationHelper.showError('The browser blocked the Gamayun tab. Allow pop-ups for this site and try again.');
      }
    },
  },
};
</script>

<style lang="less">
  .gamayun-button {
    margin-right: 10px;
  }
</style>
